import { useEffect, useState, useMemo } from 'react';

const useSelectionProject = (_data, pagination) => {

  const data = useMemo(
    () => _data?.data ?? [],
    [_data?.data]
  );
  // Case 1: isSelectedAll = true
  //      => selectedItems save all item in current page (for UI)
  // Case 2: isSelectedAll = false & isUnselectedSome = true
  //         (happen when isSelectedAll true => false)
  //      => unselectedItems save items that user unselect (for filter out)
  // Case 3: isSelectedAll = false & isUnselectedSome = false & selectedItems has any
  //         (happen when user select any item)
  //      => selectedItems save items that user select (for filter)
  // Case 4: isSelectedAll = false & isUnselectedSome = false & selectedItems don't has any
  //         (happen when user don't select any item)
  //      => default value of 4 these state

  const [isSelectedAll, setIsSelectedAll] = useState(false);
  // Flag unselectedSome is true when isSelectedAll change from true to false
  const [isUnselectedSome, setIsUnselectedSome] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  // Save items are unselected
  const [unselectedItems, setUnselectedItems] = useState([]);

  useEffect(() => {
    if (data?.length) {
      if (isSelectedAll) {
        // Case 1
        const newSelectedItems = data.map((item) => ({ projectProposalId: item.projectProposalId }));
        setSelectedItems(newSelectedItems);
      } else if (isUnselectedSome) {
        // Case 2
        const newSelectedItems = data
          .map((item) => ({ projectProposalId: item.projectProposalId }))
          .filter((item) => {
            const index = unselectedItems.findIndex(
              (unselectedItem) => unselectedItem.projectProposalId === item.projectProposalId
            );
            return index === -1;
          });
        setSelectedItems(newSelectedItems);
      } else if (!isUnselectedSome) {
        // Case 3
        const newUnselectedItems = data
          .map((item) => ({ projectProposalId: item.projectProposalId }))
          .filter(
            (item) => selectedItems.findIndex((selectedItem) => selectedItem.projectProposalId === item.projectProposalId) === -1
          );
        setUnselectedItems(newUnselectedItems);
      }
    }
  }, [pagination, data]);

  const handleAllRowSelect = () => {
    if (data.length) {
      setIsSelectedAll(true);
      // Save all items in current page
      const allSelectedItems = data.map((item) => ({ projectProposalId: item.projectProposalId }));
      setSelectedItems(allSelectedItems);
    }
    setUnselectedItems([]);
  };

  const handleAllRowUnselect = () => {
    setIsSelectedAll(false);
    setIsUnselectedSome(false);
    setSelectedItems([]);
    setUnselectedItems([]);
  };

  const handleRowSelect = (e) => {
    // Case 3
    const newSelectedItems = [...selectedItems, { projectProposalId: e.data.projectProposalId }];
    setSelectedItems(newSelectedItems);

    // Case 2
    // remove unselecteditem
    const newUnselectedItem = unselectedItems.filter((item) => item.projectProposalId !== e.data.projectProposalId);
    if (newUnselectedItem.length === 0) {
      // If all unselected items are removed => select all
      if (isUnselectedSome || newSelectedItems.length === _data.pagination.totalRecords) {
        setIsSelectedAll(true);
        setIsUnselectedSome(false);
      }
    }
    setUnselectedItems(newUnselectedItem);
  };

  const handleRowUnselect = (e) => {
    if (isSelectedAll || isUnselectedSome) {
      // Case 3
      const newUnselectedItems = [...unselectedItems, { projectProposalId: e.data.projectProposalId }];
      if (newUnselectedItems.length === _data.pagination.totalRecords) {
        setIsSelectedAll(false);
        setIsUnselectedSome(false);
        setUnselectedItems([]);
      } else {
        // Case 2
        setIsSelectedAll(false);
        setIsUnselectedSome(true);
        setUnselectedItems((cur) => [...cur, { projectProposalId: e.data.projectProposalId }]);
      }
    }
    // remove selectedItem
    const newSelectedItems = selectedItems.filter((item) => item.projectProposalId !== e.data.projectProposalId);
    setSelectedItems(newSelectedItems);
  };

  return {
    selectedItems,
    unselectedItems,
    isSelectedAll,
    isUnselectedSome,
    handleAllRowSelect,
    handleAllRowUnselect,
    handleRowSelect,
    handleRowUnselect,
    setSelectedItems
  };
};

export default useSelectionProject;
